<template>
  <div
    class="blog-core container"
    :class="isAuthorPage ? 'blog-core-author' : ''">
    <breadcrumbs
      :items="breadcrumbs"
      class="blog-core__breadcrumbs" />

    <blog-header
      v-if="!isAuthorPage"
      class="blog-core__header" />

    <article-carousel-vanilla
      v-if="showPopularArticles"
      :articles="popularArticles"
      class="blog-core__carousel" />

    <div class="blog-core__body">
      <router-view />
    </div>
    <blog-filter
      v-if="!isAuthorPage"
      class="blog-core__filter" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Breadcrumbs from 'Components/ui/Breadcrumbs/Breadcrumbs.vue';
import BlogHeader from 'Root/pages/blog/components/BlogHeader.vue';
import BlogFilter from 'Root/pages/blog/components/BlogFilter.vue';
import ArticleCarouselVanilla from 'Root/pages/blog/components/ArticleCarouselVanilla.vue';

export default {
  name: 'BlogCore',

  components: {
    ArticleCarouselVanilla,
    BlogHeader,
    BlogFilter,
    Breadcrumbs,
  },

  beforeRouteUpdate(to, from, next) {
    this.$store.commit('blog/mutateActiveGame', to.params.gameNamespace);

    next();
  },

  computed: {
    ...mapState('blog', ['activeGame', 'categories', 'activeCategory', 'activeArticle', 'popularArticles', 'author']),

    breadcrumbs() {
      const items = [
        {
          title: 'SkyCoach',
          href: '/',
        },
        {
          title: 'Blog',
          href: '/blog',
        },
      ];

      if (this.activeGame) {
        items.push({
          title: this.activeGame.fullTitle,
          href: `/blog/${this.activeGame.routeNamespace}`,
        });

        if (this.activeCategory) {
          items.push({
            title: this.activeCategory.title,
            href: `/blog/${this.activeGame.routeNamespace}/${this.activeCategory.slug}`,
          });
        }

        if (this.activeArticle) {
          items.push({
            title: this.activeArticle.title,
            href: `/blog/${this.activeGame.routeNamespace}/articles/${this.activeArticle.slug}`,
          });
        }
      }

      if (this.$route.name === 'blog__author' && this.author) {
        items.push({
          title: this.author.name,
          href: `/blog/${this.title}`,
        });
      }

      return items;
    },

    isAuthorPage() {
      return this.$route.name === 'blog__author';
    },

    showPopularArticles() {
      return this.$route.name === 'blog__root' && !this.$route.params.gameNamespace && this.popularArticles.length;
    },
  },

  beforeDestroy() {
    if (this.$store.hasModule('blog')) {
      this.$store.unregisterModule('blog');
    }
  },
};
</script>

<style lang="scss" scoped>
  .blog-core {
    padding-top: 16px;
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-gap: 16px;
  }

  .blog-core__carousel {
    margin-top: -8px;
  }

  @media screen and #{$screen-more-or-1024} {
    .blog-core {
      padding-bottom: 32px;
    }
  }

  @media screen and #{$screen-less-than-1280} {
    .blog-core__body {
      order: 2;
    }
  }

  @media screen and #{$screen-more-or-1280} {
    .blog-core {
      padding-top: 40px;
      padding-bottom: 32px;
      grid-template-columns: minmax(0, 1fr) 290px;
      grid-gap: 24px;
    }

    .blog-core-author {
      grid-template-columns: 1fr;
    }

    .blog-core__carousel {
      margin-top: -11px;
    }

    .blog-core__breadcrumbs,
    .blog-core__header,
    .blog-core__carousel {
      grid-column: 1 / -1;
    }

    .blog-core__body {
      grid-column: 1;
    }

    .blog-core__filter {
      grid-column: 2;
    }
  }
</style>
